import { Directive, Input, Optional } from '@angular/core';
import { AbstractControl, FormGroupDirective, NgForm, ValidationErrors } from '@angular/forms';
import { ErrorMessagesMap } from '../interfaces/errors';

export const DEFAULT_ERROR_MESSAGES: ErrorMessagesMap = {
  required: 'Required',
  maxlength: (err: ValidationErrors) => {
    return `Maximum of ${err.requiredLength} allowed`;
  },
  minlength: (err: ValidationErrors) => {
    return `Minimum of ${err.requiredLength} required`;
  },
  email: 'Must be a valid email.',
  passwordNotMatch: 'Passwords do not match.',
  url: 'Must be a valid url.',
  phone: 'Must be a valid phone number for the specified country.',
  nameCharacters: 'Business Name cannot contain `|` character',
};

@Directive({
  selector: '[formsErrorControlFormsSelector]',
  standalone: false,
})
export class ErrorControlDirective {
  @Input() errorMessages: ErrorMessagesMap = {};

  constructor(
    @Optional() private _parentForm: NgForm,
    @Optional() private _parentFormGroup: FormGroupDirective,
  ) {}

  errorOutput(control: AbstractControl): string {
    if (!control || !control.errors) {
      return;
    }
    const errors = Object.keys(control.errors);
    if (errors.length === 0) {
      return;
    }
    const firstErrorKey = errors[0];
    const messageHandler = this.errorMessages[firstErrorKey] || DEFAULT_ERROR_MESSAGES[firstErrorKey];
    if (typeof messageHandler === 'function') {
      return messageHandler(control.errors[firstErrorKey]);
    } else {
      return messageHandler;
    }
  }

  isErrorState(control: AbstractControl): boolean {
    const isSubmitted =
      (this._parentFormGroup && this._parentFormGroup.submitted) || (this._parentForm && this._parentForm.submitted);
    return !!(control.invalid && (control.touched || isSubmitted)) && !!control.errors;
  }
}
